export default __webpack_public_path__ + "static/media/wrigleyLogo.032910ca.png";